import { useEffect, useRef, useState } from "react";
// import { TileLayer } from "leaflet";
// import { MapContainer, Marker, Popup, TileLayer } from "react-leaflet";
import { useDispatch } from "react-redux";
import { useUniModalPortableContainer } from "../hooks/useUniModalPortableContainer";
import { dmd_utils } from "../utils/frfr-dmd-utils";
import { json_utils } from "../utils/frfr-json-utils";
import { rapidozi_dummy_utils, rapidozi_dummysmarty_utils, smartydummy_backend_special_instance } from "../utils/frfr-rapidozi-dummy-utils";
import { _zzyourmap_ajax } from "../utils/zz/zz-yourmap-ajax-adapter";
import Komentar from "./Komentar";
import UniModalPortableContainer from "./UniModalPortableContainer";
import UniModalPresentationalBottomSheetKoglovo from "./UniModalPresentationalBottomSheetKoglovo";
import { frfr_res_utils } from '../utils/frfr-res-utils';
import { js_utils } from "../utils/frfr-js-utils";
import { _zzyourmap_extract_current_destination_entity, _zzyourmap_extract_current_ymthing_entity, _zzyourmap_extract_tables_from_multitable_entities_v1 } from "../utils/zz/zz-yourmap-utils";
import YourmapLayout from "./YourmapLayout";
import { browser_utils } from "../utils/frfr-browser-utils";
import { _zzyourmap_extract_tables_from_multitable_entities_v3 } from "../utils/zz/zz-yourmap-data-prepare-2-entities";
import { yourmapNavMaker, _zzyourmap_routing_browser_url_event_popdtate_get_path, _zzyourmap_routing_browser_url_update, _zzyourmap_routing_path_to_routeState, _zzyourmap_routing_routeState_to_path, _zzyourmap_routing_event_popstate, _zzyourmap_routing_navigating_to } from "../utils/zz/zz-yourmap-routing";
import { _zzyourmap_extract_destination_map_props_1 } from "../utils/zz/zz-yourmap-map-utils";
import { _zzyourmap_extract_layer_titles_all } from "../utils/zz/zz-yourmap-layer-utils";
import { Easy69_v1 } from "../utils/frfr-easy69-utils";
import { _zzyourmap_extract_admin_options } from "../utils/zz/zz-yourmap-admin-utils";
import { _zzyourmap_preparing_multitable_rows_to_entities_v2 } from "../utils/zz/zz-yourmap-data-prepare-1-rows-j";
import { _zzyourmap_ymDataRespack_validator_quick_incomplete } from "../utils/zz/zz-yourmap-respack-utils";
import { _zzyourmap_config } from "../utils/zz/zz-yourmap-config";


//
const initialAppState = {
  // freshness: 0,
  freshness: 1,
  url_path: '',
  detected_env: null,
  routeSimple: {
    route: 'ROOT_HOME',
    // title: 'Početna',
    // breadcrumbs: [],
    route_params: {},
    freshness: 0
  },
  ulogovan: false,
  my_user_data: {},
  token: null,
  //
  route_freshness: 1,
  route_root: 'ROOT_HOME', // ROOT_HOME ROOT_MAP ROOT_DESTINATION_LIST ROOT_DESTINATION_ITEM ROOT_SMESTAJ_ITEM
  route_destination_id: null,
  route_subdestination_id: null,
  route_destination_tab: 'smestaji', // smestaji restorani
  route_smestaj_id: null,
  route_static_page: null,
  selected_destinaton: null, // TODO
  route_prev: null, // TODO route for GO BACK link
  viarouterState: {
    viarouter_current_path: '/',
    viarouter_current_params: {},
    viarouter_prev_path: '/',
  },
  //
  // seller_route: 'HOME', // HOME(DASHBOARD) DEMO CUSTOMERS TEMPLATES INSTANCES
  fetchingSubmit: false,
  //
  dmd_multitable_rows: dmd_utils.create_type_arr(),
  dmd_multitable_entities: dmd_utils.create_type_arr(),
  dmd_thing_entities: dmd_utils.create_type_arr(),
  //
  /*
  tables_data: {
    "TABLE_GOOGLE_REVIEWS": {
      type_is_arr: true,
      fatching: false,
      data: [],
    },
  },
  */
};

//
const YourmapAppContainer = (props) => {
  // -----
  const {
    setUniModalPortableContent,
    setUniModalPortableClose,
    uniModalPortableContainerPack,
  } = useUniModalPortableContainer();
  const {
    setUniModalPortableContent: setUniModalPortableContent_2,
    setUniModalPortableClose: setUniModalPortableClose_2,
    uniModalPortableContainerPack: uniModalPortableContainerPack_2,
  } = useUniModalPortableContainer();
  const {
    setUniModalPortableContent: setUniModalPortableContent_3,
    setUniModalPortableClose: setUniModalPortableClose_3,
    uniModalPortableContainerPack: uniModalPortableContainerPack_3,
  } = useUniModalPortableContainer();
  // -----
  let show_admin_panel_login = false;
  const [showAdminPanelLogin, setShowAdminPanelLogin] = useState(false);
  const url = window.location;
  useEffect(() => {
    console.log('useEffect url', url);
    const url_path = window.location.pathname;
    const url_host = window.location.host;
    const url_query = window.location.search // to get the query portion of the URL
    // const _route = _zzsurvey_router_helper(url_path, url_query);
    if (typeof url_path === 'string') {
      if (url_path === '/') {
      } else if (url_path.indexOf('/survey') === 0) {
      } if (url_path.indexOf('/admin') === 0) {
        if (url_path === '/admin') {
          setShowAdminPanelLogin(true);
        }
      }
    }
  }, [url]);
  if (showAdminPanelLogin === true) {
    show_admin_panel_login = true;
  }
  // -----
  const [appState, setAppState] = useState(initialAppState);
  // https://www.reddit.com/r/reactjs/comments/1bea6k4/no_good_way_to_pass_state_to_listener/
  const appStateRef = useRef(appState); // Create a ref to hold the current state
  useEffect(() => {
    // Update the ref to the current state on each render
    appStateRef.current = appState;
  }, [appState]); // This effect runs every time `myState` changes
  //
  const {
    route_freshness,
    route_root,
    route_destination_id,
    route_subdestination_id,
    route_destination_tab,
    route_smestaj_id,
    route_static_page,
    route_prev,
  } = appState;
  console.log('----- route_root', route_root);
  console.log('route_destination_id', route_destination_id);
  console.log('route_subdestination_id', route_subdestination_id);
  console.log('route_destination_tab', route_destination_tab);
  console.log('route_smestaj_id', route_smestaj_id);
  console.log('route_static_page', route_static_page);
  console.log('route_prev', route_prev);
  console.log('appState.freshness', appState.freshness);
  //
  //
  const [viarouterNavigationCurrentPath, setViarouterNavigationCurrentPath] = useState(window.location.pathname); // FIX popstate event not triggered
  const viarouterNavigate = (target_path) => { // go to route
    console.log('viarouterNavigate(target_path)', target_path);
    _zzyourmap_routing_browser_url_update(target_path);
    // FIX
    // navigate will not trigger popstate event so state must also be updated
    setViarouterNavigationCurrentPath(target_path);
    // also step 2
    const _routeState = _zzyourmap_routing_path_to_routeState(target_path);
    console.log(' --> NEW _routeState', _routeState);
    setAppState(state => {
      return {
        ...state,
        viarouterState: {
          ...state.viarouterState,
          viarouter_current_path: target_path,
          viarouter_prev_path: state.viarouterState.viarouter_current_path,
        },
        ..._routeState,
        route_freshness: state.route_freshness + 1,
        freshness: state.freshness + 1,
      };
    });
  };
  //
  const _goBack_href = appState.viarouterState.viarouter_prev_path;
  const handleClickGoBack = (e) => {
    e.preventDefault();
    viarouterNavigate(_goBack_href);
  };
  //
  useEffect(() => { // fill initial route
    setAppState(state => {
      // const path = appState.viarouterState.viarouter_current_path;
      const initial_path = _zzyourmap_routing_browser_url_event_popdtate_get_path();
      const _routeState = _zzyourmap_routing_path_to_routeState(initial_path);
      console.log('useEffect', 'INTIAL initial_path', initial_path);
      console.log(' --> INITIAL _routeState', _routeState);
      return {
        ...state,
        viarouterState: {
          ...state.viarouterState,
          viarouter_current_path: initial_path,
          viarouter_prev_path: '/', //
        },
        ..._routeState,
        freshness: state.freshness + 1,
      };
    });
  }, []);
  //
  useEffect(() => { // nandle history pop state event Handle browser back/forward buttons
    // componentDidMount
    const handleBrowserHistoryPopState = (e) => {
      console.log('Popstate triggered:', e.state);
      /*
      if (e.state?.is_valid_browser_history_state === true && e.state?._routeState && e.state._routeState.route_root) {
        setAppState(state => {
          return {
            ...state,
            ...e.state._routeState,
            freshness: state.freshness + 1,
          };
        });
      }
      */
      //
      /*
      setAppState(state => {
        const _routeState = _zzyourmap_routing_event_popstate(e);
        console.log('* ...seting new _routeState', _routeState)
        return {
          ...state,
          // ...e.state._routeState,
          ..._routeState,
          freshness: state.freshness + 1,
        };
      });
      */
      //
      // _set_state_by_popstate(e);
      /*
      setAppState(state => {
        const _routeState = _zzyourmap_routing_event_popstate(e);
        console.log('* ...seting new _routeState', _routeState);
        console.log('current state.freshness', state.freshness);
        console.log('current appStateRef.current.freshness', appStateRef.current.freshness);
        return {
          ...state,
          // ...appStateRef.current,
          // ...e.state._routeState,
          ..._routeState,
          freshness: state.freshness + 1,
        };
      });
      */
      setAppState(state => {
        // const _routeState = _zzyourmap_routing_event_popstate(e);
        const target_path = _zzyourmap_routing_browser_url_event_popdtate_get_path(e);
        console.log('* ...vieRouter setting new target_path', target_path);
        console.log('current state.freshness', state.freshness);
        console.log('current appStateRef.current.freshness', appStateRef.current.freshness);
        // also step 2
        const _routeState = _zzyourmap_routing_path_to_routeState(target_path);
        return {
          ...state,
          // ...appStateRef.current,
          // ...e.state._routeState,
          viarouterState: {
            ...state.viarouterState,
            viarouter_current_path: target_path,
            viarouter_prev_path: state.viarouterState.viarouter_current_path,
          },
          ..._routeState,
          freshness: state.freshness + 1,
        };
      });
    };
    window.addEventListener('popstate', handleBrowserHistoryPopState);
    /*
    // Check initial state
    setHistoryState(history.state);
    */
    // componentWillUnmount
    return () => {
      window.removeEventListener('popstate', handleBrowserHistoryPopState);
    };
  }, []);
  //
  /*
  // 2)
  useEffect(() => {
    // viarouter_current_path to _____
    setAppState(state => {
      const path = appState.viarouterState.viarouter_current_path;
      const _routeState = _zzyourmap_routing_path_to_routeState(path);
      console.log('useEffect', 'path', path);
      console.log('_routeState', _routeState);
      return {
        ...state,
        ..._routeState,
        freshness: state.freshness + 1,
      };
    });
  }, [appState.viarouterState.viarouter_current_path]);
  */
  ////-----
  // Listen to URL changes
  /*
  useEffect(() => {
    const handlePopState = (e) => {
      console.log('Popstate triggered 2 2 2:', e.state);
      console.log('window.location.pathname', window.location.pathname);
      console.log('window.location.hash', window.location.hash);
      setViarouterNavigationCurrentPath(window.location.pathname);
    };
    window.addEventListener('popstate', handlePopState);
    // Handle browser back/forward buttons
    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
  }, []);
  */
  console.log('*** *** *** viarouterNavigationCurrentPath', viarouterNavigationCurrentPath);
  ////-----
  //
  //
  const setRouteFreshnesssUpdate = () => {
    setAppState(state => {
      return {
        ...state,
        route_freshness: state.route_freshness + 1,
      };
    });
  };
  const setRouteRoot = (new_route_root, item_id) => {
    console.log('setRouteRoot', new_route_root, item_id);
    browser_utils.scroll_to_top();
    setAppState(state => {
      const {
        route_root,
        route_destination_id,
        route_subdestination_id,
        route_destination_tab,
        route_smestaj_id,
        route_static_page,
      } = state;
      const _routeState = {
        route_root,
        route_destination_id,
        route_subdestination_id,
        route_destination_tab,
        route_smestaj_id,
        route_static_page,
      };
      const _routeStatePrev = { ..._routeState };
      _routeState.route_root = new_route_root;
      if (new_route_root === 'ROOT_DESTINATION_ITEM') {
        _routeState.route_destination_id = item_id;
      } else if (new_route_root === 'ROOT_STATIC_PAGE') {
        _routeState.route_static_page = item_id;
      } else if (new_route_root === 'ROOT_MAP') {
        _routeState.route_destination_id = item_id;
      } else if (new_route_root === 'ROOT_SMESTAJ_ITEM') {
        _routeState.route_smestaj_id = item_id;
      } else if (new_route_root === 'ROOT_RESTORAN_ITEM') {
        _routeState.route_smestaj_id = item_id;
      } else if (new_route_root === 'ROOT_SERVIS_ITEM') {
        _routeState.route_smestaj_id = item_id;
      } else if (new_route_root === 'ROOT_OSTALO_ITEM') {
        _routeState.route_smestaj_id = item_id;
      } else {
        _routeState.route_destination_id = null;
        _routeState.route_subdestination_id = null;
        _routeState.route_static_page = null;
      }
      // TODO
      /*
      if (new_route_root === 'ROOT_SMESTAJ_ITEM') {
      } else {
        _routeState.route_smestaj_id = null;
      }
      */
      if (new_route_root === 'ROOT_SMESTAJ_ITEM' || new_route_root === 'ROOT_RESTORAN_ITEM' || new_route_root === 'ROOT_SERVIS_ITEM' || new_route_root === 'ROOT_OSTALO_ITEM') {
      } else {
        // RESET ROUTE
        _routeState.route_subdestination_id = null;
        _routeState.route_smestaj_id = null;
        _routeState.route_static_page = null;
      }

      /*
      const updatedState = {
        ...state,
        route_root: new_route_root,
        freshness: state.freshness + 1,
      };
      */
      //
      // const state = { page: 'dashboard', userId: 123, filters: ['active'] };
      // history.pushState(state, '', '/dashboard');
      console.log('* * * history push _routeStatePrev', _routeStatePrev);
      _zzyourmap_routing_navigating_to(_routeState, _routeStatePrev);
      // return state; //
      //
      // return updatedState;
      return {
        ...state,
        ..._routeState,
        route_prev: _routeStatePrev,
        freshness: state.freshness + 1,
      };;
    });
  };
  const setRouteSubdestination = (subdestination_id) => {
    setAppState(state => {
      const {
        route_root,
        route_destination_id,
        route_subdestination_id,
        route_destination_tab,
        route_smestaj_id,
      } = state;
      const _routeState = {
        route_root,
        route_destination_id,
        route_subdestination_id,
        route_destination_tab,
        route_smestaj_id,
      };
      const _routeStatePrev = { ..._routeState };
      _routeState.route_subdestination_id = subdestination_id;
      // RESET ROUTE
      _routeState.route_smestaj_id = null;
      //
      // const state = { page: 'dashboard', userId: 123, filters: ['active'] };
      // history.pushState(state, '', '/dashboard');
      console.log('* * * history push _routeStatePrev', _routeStatePrev);
      _zzyourmap_routing_navigating_to(_routeState, _routeStatePrev);
      // return state; //
      //
      return {
        ...state,
        // route_destination_tab: tab_key,
        // route_smestaj_id: null,
        ..._routeState,
        route_prev: _routeStatePrev,
        freshness: state.freshness + 1,
      };
    });
  };
  const setRouteDestinationTab = (tab_key) => {
    console.log('setRouteDestinationTab(tab_key)', tab_key);
    setAppState(state => {
      const {
        route_root,
        route_destination_id,
        route_subdestination_id,
        route_destination_tab,
        route_smestaj_id,
      } = state;
      const _routeState = {
        route_root,
        route_destination_id,
        route_subdestination_id,
        route_destination_tab,
        route_smestaj_id,
      };
      const _routeStatePrev = { ..._routeState };
      _routeState.route_destination_tab = tab_key;
      // RESET ROUTE
      _routeState.route_smestaj_id = null;
      //
      // const state = { page: 'dashboard', userId: 123, filters: ['active'] };
      // history.pushState(state, '', '/dashboard');
      console.log('* * * history push _routeStatePrev', _routeStatePrev);
      _zzyourmap_routing_navigating_to(_routeState, _routeStatePrev);
      // return state; //
      //
      return {
        ...state,
        // route_destination_tab: tab_key,
        // route_smestaj_id: null,
        ..._routeState,
        route_prev: _routeStatePrev,
        freshness: state.freshness + 1,
      };
    });
  };
  const handleClickHome = (e) => {
    e.preventDefault();
    // dispatch(actionRouteSet('/POCETNA'));
    // setRouteRoot('ROOT_HOME');
    viarouterNavigate(yourmapNavMaker.ROOT_HOME());
  };
  const _handleClickHome = () => {
    // e.preventDefault();
    // dispatch(actionRouteSet('/POCETNA'));
    // setRouteRoot('ROOT_HOME');
    viarouterNavigate(yourmapNavMaker.ROOT_HOME());
  };
  const handleClickGoBack_OLD = (e) => {
    // dispatch(actionRouteSet('/POCETNA'));
    console.log('GO BACK');
    browser_utils.scroll_to_top();
    setAppState(state => {
      let _is_go_back_different = false;
      if (state.route_prev && state.route_prev.route_root) {
        const {
          route_root,
          route_destination_id,
          route_destination_tab,
          route_smestaj_id,
        } = state;
        let _routeState = {
          route_root,
          route_destination_id,
          route_destination_tab,
          route_smestaj_id,
        };
        console.log('DEBUG _routeState', _routeState);
        console.log('DEBUG ...after GO BACK will be');
        console.log('DEBUG state.route_prev', state.route_prev);
        if (route_root === state.route_prev.route_root) {
          console.log('route_root === state.route_prev.route_root');
          _is_go_back_different = false;
        } else {
          _is_go_back_different = true;
        }
        console.log('_is_go_back_different', _is_go_back_different);
        if (_is_go_back_different === true) { // CASE go back different
          const _routeStatePrev = { ..._routeState };
          _routeState = { ...state.route_prev };
          console.log('* * * history push _routeStatePrev', _routeStatePrev);
          _zzyourmap_routing_navigating_to(_routeState, _routeStatePrev);
          // return state; //
          //
          // return updatedState;
          return {
            ...state,
            ..._routeState,
            route_prev: _routeStatePrev,
            freshness: state.freshness + 1,
          };
        } else { // CASE go back unchanged
          // FIX
          console.log('* * * ERROR: GO BACK rozte_prev is the same');
          if (_is_go_back_different !== true) { // FIX if something wrong go back to default route HOME
            console.log('FIX go default route HOME');
            _handleClickHome();
            // TODO
          }
          //
          return state; // return unchanged state
        }
      } else {
        console.log('* * * ERROR: GO BACK no rozte_prev');
        console.log('DEBUG state.route_prev', state.route_prev);
        // FIX
        if (_is_go_back_different !== true) { // FIX if something wrong go back to default route HOME
          console.log('FIX go default route HOME');
          _handleClickHome();
          // TODO
        }
        //
        return state; // return unchanged state
      }
    });
  };
  const handleClickMenuOption = (what, payload) => {
    setRouteRoot(what, payload);
  };
  //
  //
  // const [tempArr, setTempArr] = useState([]);
  const fetchGetAll = () => {
    //
    const vr_tablename = 'proba_tablename';
    const endpoint = 'get_all'; //
    //
    setAppState(state => {
      return {
        ...state,
        dmd_multitable_rows: dmd_utils.update_fetching(state.dmd_multitable_rows, true),
        dmd_multitable_entities: dmd_utils.update_fetching(state.dmd_multitable_entities, true),
      };
    });
    //
    _zzyourmap_ajax.get_all()
      .then(response => {
        console.log('response', response);
        if (frfr_res_utils.is_srf(response?.data)) {
          const res_payload = frfr_res_utils.srf_extract_payload(response.data);
          //
          // const rows = res_payload?.funcres?.$dbres?.rows;
          // const rows = res_payload?.rows;
          // const rows_decoded_backend = res_payload?.rows_decoded_backend;
          const ymDataRespack = res_payload?.ymDataRespack;
          console.log('ymDataRespack', ymDataRespack);
          // if (Array.isArray(rows)) {
          // if (Array.isArray(rows_decoded_backend)) {
          if (_zzyourmap_ymDataRespack_validator_quick_incomplete(ymDataRespack)) {
            console.log('ymDataRespack is VALID :)');
            // console.log('rows', rows);
            const rows_decoded_backend = ymDataRespack.rows_decoded_backend;
            // console.log('rows', rows_decoded_backend);
            let rows_prepared = [];
            // let rows_prepared = _zzyourmap_multitable_prepare_rows(rows);
            // console.log('rows_prepared', rows_prepared);
            // setTempArr(rows_prepared);
            // let entities_prepared = _zzyourmap_multitable_rows_to_entities(rows_prepared);
            // let entities_prepared = _zzyourmap_preparing_multitable_rows_to_entities_v2(rows);
            let entities_prepared = rows_decoded_backend;
            console.log('entities_prepared', entities_prepared);
            setAppState(state => {
              return {
                ...state,
                // dmd_multitable_rows: dmd_utils.update_arr(state.dmd_multitable_rows, rows_prepared, false),
                dmd_multitable_entities: dmd_utils.update_arr(state.dmd_multitable_entities, entities_prepared, false),
              };
            });
          }
        }
      })
      .catch(err => {
        console.log('CATCH ERROR in _test_fetch_get_all', err);
      })

  };
  //
  useEffect(() => {
    fetchGetAll();
  }, []);

  //
  const dmd_multitable_entities = appState.dmd_multitable_entities;
  /*
  const {
    // current_destination_entity,
    //// current_smestaj_entity,
    //
    destination_entities,
    destination_entities_adm,
    ymthing_entities,
    smestaj_entities,
    smestaj_entities_adm,
    restoran_entities,
    restoran_entities_adm,
    ymostalo_v1_entities,
    ymostalo_v1_entities_adm,
    // markerable_entities,
    //
    //// options_adm_parent_of_destination,
    //// options_adm_parent_of_smestaj,
  } = _zzyourmap_extract_tables_from_multitable_entities_v1(dmd_utils.dmd_to_always_arr(dmd_multitable_entities), route_destination_id, route_smestaj_id);
  */
  ////
  const {
    destination_entities,
    destination_entities_adm,
    ymthing_entities,
    ymthing_entities_adm,
    // smestaj_entities,
    // smestaj_entities_adm,
    // restoran_entities,
    // restoran_entities_adm,
    ymostalo_v1_entities,
    ymostalo_v1_entities_adm,
    // markerable_entities,
    //
    lookup_pack,
  } = _zzyourmap_extract_tables_from_multitable_entities_v3(dmd_utils.dmd_to_always_arr(dmd_multitable_entities));
  const smestaj_entities = [];
  const smestaj_entities_adm = [];
  const restoran_entities = [];
  const restoran_entities_adm = [];
  //
  const destination_entities_fetching = dmd_utils.is_fetching(dmd_multitable_entities);
  const ymthing_entities_fetching = destination_entities_fetching;
  const smestaj_entities_fetching = destination_entities_fetching;
  const restoran_entities_fetching = destination_entities_fetching;
  const ymostalo_v1_entities_fetching = destination_entities_fetching;
  // console.log('ENRICHED destination_entities', destination_entities);
  const current_destination_entity = _zzyourmap_extract_current_destination_entity(destination_entities, route_destination_id);
  const current_thing_entity = _zzyourmap_extract_current_ymthing_entity(ymthing_entities, ymostalo_v1_entities, route_smestaj_id);
  const current_smestaj_entity = current_thing_entity; // TODO
  const destinations_pupular_entities = Easy69_v1.fix_always_arr(destination_entities, 4);
  console.log('destinations_pupular_entities', destinations_pupular_entities);
  //
  //
  const {
    options_adm_parent_of_destination,
    options_adm_parent_of_smestaj,
  } = _zzyourmap_extract_admin_options(destination_entities);
  //
  const layer_titles_all = _zzyourmap_extract_layer_titles_all(ymthing_entities, ymostalo_v1_entities);

  //
  let map_props_1 = {
    map_img_url: '',
    w: 0,
    h: 0,
  };
  if (current_destination_entity?.of_id > 0) {
    map_props_1 = _zzyourmap_extract_destination_map_props_1(current_destination_entity, route_subdestination_id, lookup_pack);
  }
  //
  let header_img_url = '';
  const header_img_default = _zzyourmap_config.header_default_img_url_full
  header_img_url = header_img_default;
  if (route_root === 'ROOT_DESTINATION_ITEM') {
    if (current_destination_entity?.of_id > 0) {
      // const img_url_full = _zzyourmap_extract_destination_main_img_url(current_destination_entity);
      const img_url_full = current_destination_entity._main_img_url;
      header_img_url = img_url_full;
    }
  } else if (route_root === 'ROOT_SMESTAJ_ITEM') {
    if (current_smestaj_entity?.of_id > 0) {
      // const img_url_full = _zzyourmap_extract_smestaj_main_img_url(current_smestaj_entity);
      const img_url_full = current_smestaj_entity._main_img_url;
      header_img_url = img_url_full;
    }
  }
  console.log('header_img_url', header_img_url);

  ////
  // TODO
  const refreshEntitiesDummy = () => {
    const _api_methods = smartydummy_backend_special_instance('YOURMAPAPP', {});
    ////
    console.log('refresh()', '');
    // korak 1 - dispetchujemo akciju uz prikaz spinera
    // dispatch({ type: types.LIB_CNC_S4_TEMPLATE_LIST_FETCHING });
    // setLibItems([]);
    // setFetching(true);
    // korak 2 - fetchujemo podatke
    _api_methods.api_get_arr('TABLE_DESTINATION')
      .then((response) => {
        // korak 3 - zavrseno fetchovanje
        // console.log(response);
        console.log('response', response);
        if (true) {
          // const res_payload = frfr_res_utils.srf_extract_payload(response);
          // console.log(response);
          console.log('response of api_methods.api_get_arr(TABLE_DESTINATION)', response);
          /*
          if (Array.isArray(res_payload)) {
            setLibItems(res_payload);
          }
          */
          // dispatch({ type: '__actionLibMaterijalLimCreate SUCCESS', payload: res_payload })
          // dispatch(actionShowToast('CNC Program S4 template uspešno izmenjen!', tclocal.GREEN));
          // dispatch(actionRouteRefresh());
        } else {
          // console.log(response);
          // dispatch({ type: '__actionLibMaterijalLimCreate FAIL' })
          // dispatch(actionShowToast('Greska! :(', tclocal.RED));
        }
        // setFetching(false);
      })
      .catch((err) => {
        // setFetching(false);
        // errCatched();
      })
  };
  ////

  //
  //
  let breadcrumbs = [];
  breadcrumbs.push({
    key: 'HOME',
    title: 'Početna',
    handleClick: (e) => {
      e.preventDefault();
      // handleClickHome(e);
      viarouterNavigate(yourmapNavMaker.ROOT_HOME());
    },
    href: yourmapNavMaker.ROOT_HOME(),
  });
  if (route_destination_id > 0 || js_utils.is_string_not_empty(route_destination_id)) {
    breadcrumbs.push({
      key: 'ROOT_DESTINATION_ITEM',
      title: (typeof current_destination_entity?.destinacija_naslov === 'string' ? current_destination_entity.destinacija_naslov : 'Destinacija'),
      handleClick: (e) => {
        e.preventDefault();
        // setRouteRoot('ROOT_DESTINATION_ITEM', route_destination_id); 
        viarouterNavigate(yourmapNavMaker.ROOT_DESTINATION_ITEM(route_destination_id));
      },
      href: yourmapNavMaker.ROOT_DESTINATION_ITEM(route_destination_id),
    });
    if (route_root === 'ROOT_SMESTAJ_ITEM') {
      breadcrumbs.push({
        key: 'ROOT_SMESTAJ_ITEM',
        title: 'Smeštaji',
        handleClick: (e) => {
          e.preventDefault();
          // setRouteRoot('ROOT_DESTINATION_ITEM', route_destination_id); 
          viarouterNavigate(yourmapNavMaker.smestaj_list(route_destination_id));
        },
        href: yourmapNavMaker.smestaj_list(route_destination_id),
      });
    } else if (route_root === 'ROOT_RESTORAN_ITEM') {
      breadcrumbs.push({
        key: 'ROOT_RESTORAN_ITEM',
        title: 'Restorani',
        handleClick: (e) => {
          e.preventDefault();
          // setRouteRoot('ROOT_DESTINATION_ITEM', route_destination_id);
          viarouterNavigate(yourmapNavMaker.restoran_list(route_destination_id));
        },
        href: yourmapNavMaker.restoran_list(route_destination_id),
      });
    } else if (route_root === 'ROOT_SERVIS_ITEM') {
      breadcrumbs.push({
        key: 'ROOT_SERVIS_ITEM',
        title: 'Servisi',
        handleClick: (e) => {
          e.preventDefault();
          // setRouteRoot('ROOT_DESTINATION_ITEM', route_destination_id);
          viarouterNavigate(yourmapNavMaker.servis_list(route_destination_id));
        },
        href: yourmapNavMaker.servis_list(route_destination_id),
      });
    } else if (route_root === 'ROOT_PRODAVNICA_ITEM') {
      breadcrumbs.push({
        key: 'ROOT_PRODAVNICA_ITEM',
        title: 'Prodavnice',
        handleClick: (e) => {
          e.preventDefault();
          // setRouteRoot('ROOT_DESTINATION_ITEM', route_destination_id);
          viarouterNavigate(yourmapNavMaker.prodavnica_list(route_destination_id));
        },
        href: yourmapNavMaker.prodavnica_list(route_destination_id),
      });
    } else if (route_root === 'ROOT_AKTIVNOST_ITEM') {
      breadcrumbs.push({
        key: 'ROOT_AKTIVNOST_ITEM',
        title: 'Aktivnosti',
        handleClick: (e) => {
          e.preventDefault();
          // setRouteRoot('ROOT_DESTINATION_ITEM', route_destination_id);
          viarouterNavigate(yourmapNavMaker.aktivnost_list(route_destination_id));
        },
        href: yourmapNavMaker.aktivnost_list(route_destination_id),
      });
    } else if (route_root === 'ROOT_ZNAMENITOST_ITEM') {
      breadcrumbs.push({
        key: 'ROOT_ZNAMENITOST_ITEM',
        title: 'Znamenitosti',
        handleClick: (e) => {
          e.preventDefault();
          viarouterNavigate(yourmapNavMaker.znamenitost_list(route_destination_id));
        },
        href: yourmapNavMaker.znamenitost_list(route_destination_id),
      });
    } else if (route_root === 'ROOT_OSTALO_ITEM') {
      breadcrumbs.push({
        key: 'ROOT_OSTALO_ITEM',
        title: 'Ostalo',
        handleClick: (e) => {
          e.preventDefault();
          viarouterNavigate(yourmapNavMaker.ostalo_list(route_destination_id));
        },
        href: yourmapNavMaker.ostalo_list(route_destination_id),
      });
    } else if (route_root === 'ROOT_BLOG_ITEM') {
      breadcrumbs.push({
        key: 'ROOT_BLOG_ITEM',
        title: 'Blog',
        handleClick: (e) => {
          e.preventDefault();
          viarouterNavigate(yourmapNavMaker.blog_list(route_destination_id));
        },
        href: yourmapNavMaker.blog_list(route_destination_id),
      });
    }
  }
  console.log('route_root', route_root, 'breadcrumbs', breadcrumbs);
  //
  //
  const appPack = {
    appState,
    setUniModalPortableContent,
    setUniModalPortableClose,
    setUniModalPortableContent_2,
    setUniModalPortableClose_2,
    setUniModalPortableContent_3,
    setUniModalPortableClose_3,
    //
    show_admin_panel_login,
    lookup_pack,
    //
    route_freshness,
    route_root,
    route_destination_id,
    route_subdestination_id,
    route_destination_tab,
    route_smestaj_id,
    route_static_page,
    setRouteFreshnesssUpdate,
    setRouteRoot,
    setRouteSubdestination,
    setRouteDestinationTab,
    handleClickHome,
    handleClickMenuOption,
    breadcrumbs,
    handleClickGoBack,
    _goBack_href,
    //
    viarouterNavigate,
    viarouterState: appState.viarouterState,
    viarouter_current_path: appState.viarouterState.viarouter_current_path,
    viarouter_prev_path: appState.viarouterState.viarouter_prev_path,
    //
    fetchGetAll,
    // tempArr, // TODO
    header_img_url,
    map_props_1,
    dmd_multitable_rows: appState.dmd_multitable_rows,
    dmd_multitable_entities,
    current_destination_entity,
    // current_destination_slug, // TODO
    current_thing_entity,
    current_smestaj_entity,
    //
    destination_entities,
    destination_entities_fetching,
    destination_entities_adm,
    // subdestination_entities,
    ymthing_entities,
    ymthing_entities_fetching,
    ymthing_entities_adm,
    smestaj_entities,
    smestaj_entities_fetching,
    smestaj_entities_adm,
    restoran_entities,
    restoran_entities_fetching,
    restoran_entities_adm,
    ymostalo_v1_entities,
    ymostalo_v1_entities_fetching,
    ymostalo_v1_entities_adm,
    // markerable_entities,
    //
    // slug_to_id_lookup_obj, TODO
    destinations_pupular_entities,
    options_adm_parent_of_destination,
    options_adm_parent_of_smestaj,
    layer_titles_all,
  };
  //
  return (
    <>
      <YourmapLayout appPack={appPack} />
      <div className="yourmap__modal-root yourmap-theme__scope-admin-panel">
        <UniModalPortableContainer
          uniModalPortableContainerPack={uniModalPortableContainerPack}
          ComponentModal={UniModalPresentationalBottomSheetKoglovo}
          containerOptions={null}
        />
        <UniModalPortableContainer
          uniModalPortableContainerPack={uniModalPortableContainerPack_2}
          ComponentModal={UniModalPresentationalBottomSheetKoglovo}
          containerOptions={null}
        />
        <UniModalPortableContainer
          uniModalPortableContainerPack={uniModalPortableContainerPack_3}
          ComponentModal={UniModalPresentationalBottomSheetKoglovo}
          containerOptions={null}
        />
      </div>
    </>
  );
};

export default YourmapAppContainer;